export default __webpack_public_path__ + "static/media/video-course-icon.c2239bf4.svg";